// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.dev.ts` with `environmentDev.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const SYSTEM_NAME = 'semafor';
export const SYSTEM_NAME_AUTH = 'AUTH';

const UserRolesEnum = {
    SuperAdmin: "SUPERADMIN",
    Admin: "SEM_ADMIN",
    User: "SEM_USER",
    Mobile: "SEM_MOBILE",
    MobAdmin: "SEM_MOB_ADMIN",
} as const;

export const environment = {
    production: false,
    // useHttps: false,
    // isLocal: true,
    useHttps: true,
    isLocal: false,
    systemName: SYSTEM_NAME,
    organizationName: 'Technická univerzita v Košiciach',
    organizationWebsiteUrl: 'https://www.tuke.sk/',
    organizationSupportEmail: '',
    organizationSupportPhone: '',
    availableLanguages: ['sk', 'en'],
    defaultLocale: 'sk',   
    // API_URL: `http://localhost:8080/api`,
    // BASE_API_URL: `https://api.portal.tuke.sk/api`,
    // WEBSOCKET_URL: `http://localhost:8080`,
    MOBILE_APP_FILE_NAME: 'semafor-dev-debug-v1.0-dev.apk',
    CARD_READER_FILE_NAME: 'card_installer-dev.zip',
    API_URL: `https://api.semafor.portal.dev.docker-node1.uvt.tuke.sk/api`,
    BASE_API_URL: `https://auth.api.portal.dev.msweb.tuke.sk`,
    WEBSOCKET_URL: `https://api.semafor.portal.dev.docker-node1.uvt.tuke.sk`,

    SHOW_MANUAL_SEARCH: true,
    
    userRoles: {
        All: [
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.User,
            UserRolesEnum.Admin,
            UserRolesEnum.MobAdmin,
        ],
        Admin: [
            UserRolesEnum.Admin,
            UserRolesEnum.SuperAdmin,
            UserRolesEnum.MobAdmin,
        ],
        Users: [
            UserRolesEnum.User,
        ],
        Mobile: [
            UserRolesEnum.Mobile,
        ],
        MobAdmin: [
            UserRolesEnum.MobAdmin,
        ],
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
